
export const URLS = {
  auth: {
    login: 'users/authenticate',
    forgotpassword: 'users/forgot-password/email',
    otpVerfiy: 'users/verify-otp',
    whatsappOtpVerify: 'users/whatsapp-otp/verify',
    setPassword: 'users/set-password',
    savePatientsx: 'users/save-patients-x',
    saveProvidersX: 'users/save-providers-x',
    saveHospitalsX: 'users/save-hospitals-x',
    userDetails: 'users/userDetails?user_id={id}',
  },
  school: {
    getSchoolsList: `resource/schools`,
    getSchoolsInfo: `resource/schools/{id}`,
    saveSchools: `resource/schools`,
    editDeleteSchools: `resource/schools/{id}`,
  },
  users: {
    getUsersList: `resource/users`,
    getUsersInfo: `resource/users/{id}`,
    saveUsers: `resource/users`,
    editDeleteUsers: `resource/users/{id}`,
  },
  staff: {
    getStaffsList: `resource/staffs`,
    getStaffsFullList: `resource/staffs/all`,
    getStaffsInfo: `resource/staffs/{id}`,
    saveStaffs: `resource/staffs`,
    editDeleteStaffs: `resource/staffs/{id}`,
  },
  class: {
    getClassesList: `resource/school-classes`,
    getClassesFullList: `resource/school-classes/all`,
    getClassesInfo: `resource/school-classes/{id}`,
    saveClasses: `resource/school-classes`,
    editDeleteClasses: `resource/school-classes/{id}`,
  },
  provider: {
    getProvidersList: `resource/providers`,
    getProvidersFullList: `resource/providers/all`,
    getProvidersInfo: `resource/providers/{id}`,
    saveProviders: `resource/providers`,
    providerinfo: `users/providerinfo`,
    editDeleteProviders: `resource/providers/{id}`,
  },
  unavailability: {
    getUnavailabilityList: `resource/provider_unavailabilities`,
    getUnavailabilityFullList: `resource/provider_unavailabilities/all`,
    getUnavailabilityInfo: `resource/provider_unavailabilities/{id}`,
    saveUnavailability: `resource/provider_unavailabilities`,
    editDeleteUnavailability: `resource/provider_unavailabilities/{id}`,
  },
  customizedAvailability: {
    getCustomizedavailabilityList: `resource/custom_availability_details`,
    getCustomizedavailabilityFullList: `resource/custom_availability_details/all`,
    getCustomizedavailabilityInfo: `resource/custom_availability_details/{id}`,
    saveCustomizedavailability: `resource/custom_availability_details`,
    editDeleteCustomizedavailability: `resource/custom_availability_details/{id}`,
  },
  student: {
    getStudentList: `resource/student`,
    getStudentFullList: `resource/student/all`,
    getStudentInfo: `resource/student/{id}`,
    saveStudent: `resource/student`,
    editDeleteStudent: `resource/student/{id}`,
  },
  master: {
    getMasterBySlugFirst: `resource/masters/first?slug={slug}&order_by=name&dir=1&patient_id={patient_id}`,
    getCountryList: `resource/masters/all?slug=country&order_by=name&dir=1`,
    getMasterBySlugList: `resource/masters/all?slug={slug}&order_by={name}&dir=1&patient_id={patient_id}`,
    getMasterByAttrList: `resource/masters/all?attr_slug={slug}&order_by=id&dir=1&with_values={w_val}&patient_id={patient_id}`,
    getSpecialityList: `resource/masters/all?slug=speciality&order_by=name&dir=1&speciality_type={s_type}`,
    getAssementFormTypeList: `resource/masters/all?slug=assessment-group&order_by=name&dir=1`,
    getVitalsList: `resource/masters/all?slug=vitals&order_by=id&dir=1`,
    getActivityList: `resource/masters/all?slug=activity&order_by=id&dir=1`,
    getDietList: `resource/masters/all?slug=food-diet&order_by=id&dir=1`,
    getDocsList: `resource/masters/all?slug=document-source&order_by=id&dir=1`,
    getImmunisationList: `resource/masters/all?slug=immunisation&order_by=id&dir=1&patient_id={id}`,
    getFamilyHistoryList: `resource/masters/all?slug=family_history_diseases&order_by=id&dir=1&patient_id={id}`,
    getTimezoneList: `resource/timezone/all`,
    getFullList: `resource/masters/all`,
    getList: `resource/masters`,
    getRosList: `resource/masters/all?slug=ros&order_by=id&dir=1&patient_id={id}`,
    getMedicineStrengthList: `resource/masters/all?slug=measurement-strength&order_by=name&dir=1`,
    getLoginUserInfo: `users/info`,
    getPEList: `resource/masters/all?slug=physical-examination&order_by=id&dir=1&patient_id={id}`,
    getMasterx: `users/get-master-x?slug={slug}&order_by=name&dir=1`,
    getTimezoneX: `users/get-timezone-x`,
    authA2ZGuest: `users/auth-guest-x`,
    authHospitalGuest: `users/auth-guest-x`,
    MasterInfo: `resource/masters/{id}`,
    Analytics: `analytics`,
    Medicines: `resource/medicines/all`,
  },
  customMaster: {
    infoUrl: `resource/custom/masters/list`,
    getList: `resource/custom_masters`,
    MasterInfo: `resource/custom_masters/{id}`,
  },
  settings: {
    savePassword: `users/change-password`,
    twofa: `users/twofa`,
    communication: `users/communication`,
  },
  account: {
    editUserAccount: `resource/users/{id}`,
    ActivateAccount: `users/activate-accounts-x?token={id}`,
  },
  forms: {
    // getAssementFormsList: `resource/masters`,
    getAssementFormsList: `resource/form`,
    getAssementFormsFullList: `resource/form/all`,
    assessmentPDF_globalx: `assessmentPDF_globalx`,
  },
  health: {
    getVitalsList: `resource/vitals`,
    getVitalsFullList: `resource/vitals/all`,
    getVitalsInfo: `resource/vitals/{id}`,
    saveVitals: `resource/vitals`,
    editDeleteVitals: `resource/vitals/{id}`,
    getHealthsInfo: `resource/patientHealth/{id}`,
    getHealthsList: `resource/patientHealth`,
    getHealthsFullList: `resource/patientHealth/all`,
    saveHealths: `resource/patientHealth`,
    editDeleteHealths: `resource/patientHealth/{id}`,
    healthPDF: `healthPDF`,
    vitalsPDF: `vitalsPDF`,
    activityWellnessPDF: `activityWellnessPDF`,
    vitalsPDF_globalx: `vitalsPDF_globalx`,
    healthPDF_globalx: `healthPDF_globalx`,
    activityWellnessPDF_globalx: `activityWellnessPDF_globalx`
  },
  history: {
    getHistoryInfo: `resource/patientHistories/{id}`,
    getHistoryList: `resource/patientHistories`,
    getHistoryFirst: `resource/patientHistories/first`,
    getHistoryFullList: `resource/patientHistories/all`,
    saveHistory: `resource/patientHistories`,
    editDeleteHistory: `resource/patientHistories/{id}`,
    getHistorybyUserId: `resource/patientHistories/all?user_id={id}&slug={slug}`,
    historyPDF: `historyPDF`,
    historyPDF_globalx: `historyPDF_globalx`,
    familyHistoryPDF_globalx: `familyHistoryPDF_globalx`,
    ReviewOfSystem_globalx: `ReviewOfSystem_globalx`,
    physicalExamination_globalx: `physicalExamination_globalx`,
    assessmentPDF_globalx: `assessmentPDF_globalx`,
  },
  assessment: {
    getAssessmentList: `resource/form_submitted_answers`,
    getAssessmentFullList: `resource/form_submitted_answers/all`,
    getAssessmentInfo: `resource/form_submitted_answers/{id}`,
    saveAssessment: `resource/form_submitted_answers`,
    editDeleteAssessment: `resource/form_submitted_answers/{id}`,
  },
  immunisation: {
    getImmunisationList: `resource/immunisation`,
    getAllImmunisationList: `resource/immunisation/all`,
    getImmunisationInfo: `resource/immunisation/{id}`,
    saveImmunisation: `resource/immunisation`,
    editDeleteImmunisation: `resource/immunisation/{id}`,
    immunisationPDF_globalx: `immunisationPDF_globalx`,
  },
  activity: {
    getActivityList: `resource/activity_wellness`,
    getAllActivityList: `resource/activity_wellness/all`,
    getActivityInfo: `resource/activity_wellness/{id}`,
    saveActivity: `resource/activity_wellness`,
    editDeleteActivity: `resource/activity_wellness/{id}`,
  },
  document: {
    getDocumentsList: `resource/docs`,
    getDocumentsFullList: `resource/docs/all`,
    uploadAvatar: `users/uploadAvatar`,
    getDocumentsInfo: `resource/docs/{id}`,
    saveDocuments: `resource/docs`,
    editDeleteDocuments: `resource/docs/{id}`,
    getFilePath: `get-document-url`,
    docsPDF: `docsPDF`,
    docsPDF_globalx: `docsPDF_globalx`,
  },
  familhistory: {
    getFamilyHistoryList: `resource/familyHistories`,
    getAllFamilyHistoryList: `resource/familyHistories/all`,
    getFamilyHistoryInfo: `resource/familyHistories/{id}`,
    saveFamilyHistory: `resource/familyHistories`,
    editDeleteFamilyHistory: `resource/familyHistories/{id}`,
  },
  dynamicForms: {
    getList: `resource/dynamicForms`,
    getAllList: `resource/dynamicForms/all`,
    getInfo: `resource/dynamicForms/{id}`,
    save: `resource/dynamicForms`,
    editDelete: `resource/dynamicForms/{id}`,
  },
  reviewofSystem: {
    getList: `resource/ReviewOfSystem`,
    getListAll: `resource/ReviewOfSystem/all`,
    getInfo: `resource/ReviewOfSystem/{id}`,
    save: `resource/ReviewOfSystem`,
    editDelete: `resource/ReviewOfSystem/{id}`,
    ReviewOfSystem_globalx: `ReviewOfSystem_globalx`,
  },
  consult: {
    getConsultsSummary: `teleconsult/summary`,
    getConsultsPdfSummary: `teleconsult/summaryPdf`,
    getPatientsSummary: `patient/summary`,
    getPatientsPdfSummary: `patient/summaryPdf`,
    getConsultsList: `resource/consults`,
    getConsultsFullList: `resource/consults/all`,
    getConsultsInfo: `resource/consults/{id}`,
    saveConsults: `resource/consults`,
    checkContract: `contract/check?type={type}`,
    editDeleteConsults: `resource/consults/{id}`,
  },
  physical_examination: {
    getList: `resource/physical_examinations`,
    getListAll: `resource/physical_examinations/all`,
    getInfo: `resource/physical_examinations/{id}`,
    save: `resource/physical_examinations`,
    editDelete: `resource/physical_examinations/{id}`,
    physicalExamination_globalx: `physicalExamination_globalx`,
  },
  patient: {
    getPatientsList: `resource/patients`,
    getPatientsFirst: `resource/patients/first`,
    getPatientsFullList: `resource/patients/all`,
    getPatientsInfo: `resource/patients/{id}`,
    savePatients: `resource/patients`,
    editDeletePatients: `resource/patients/{id}`,
    editDeletePeriperal: `getOtp/{id}`,
    getTrackerReport: `trackAnalytics`,
    getReport: `reportXls`,
    getAdvancedReport: `advanced_reportXls`,
  },
  scancenter: {
    getScanCentersList: `resource/scan_centers`,
    getScanCentersFullList: `resource/scan_centers/all`,
    getScanCentersInfo: `resource/scan_centers/{id}`,
    saveScanCenters: `resource/scan_centers`,
    editDeleteScanCenters: `resource/scan_centers/{id}`,
  },
  hospital: {
    getHospitalsList: `resource/hospitals`,
    getHospitalsInfo: `resource/hospitals/{id}`,
    saveHospitals: `resource/hospitals`,
    editDeleteHospitals: `resource/hospitals/{id}`,
    getHospitalListAll: `resource/hospitals/all`,
  },
  location: {
    getLocationsList: `resource/LocationIncharge`,
    getLocationsInfo: `resource/LocationIncharge/{id}`,
    saveLocations: `resource/LocationIncharge`,
    editDeleteLocations: `resource/LocationIncharge/{id}`,
    getLocationListAll: `resource/LocationIncharge/all`,
  },
  ambulance: {
    getAmbulancesList: `resource/ambulance`,
    getAmbulancesInfo: `resource/ambulance/{id}`,
    saveAmbulances: `resource/ambulance`,
    editDeleteAmbulances: `resource/ambulance/{id}`,
    getAmbulanceListAll: `resource/ambulance/all`,
    getAmbulanceStaffsList: `resource/AmbulanceStaff`,
    saveAmbulanceStaffs: `resource/AmbulanceStaff`,
    editDeleteAmbulanceStaffs: `resource/AmbulanceStaff/{id}`,
  },
  camera: {
    getCamerasList: `resource/cameras`,
    getCamerasInfo: `resource/cameras/{id}`,
    saveCameras: `resource/cameras`,
    editDeleteCameras: `resource/cameras/{id}`,
    getCameraListAll: `resource/cameras/all`,
  },
  hospital_groups: {
    getHospitalGroupsList: `resource/hospital_groups`,
    getHospitalGroupsInfo: `resource/hospital_groups/{id}`,
    saveHospitalGroups: `resource/hospital_groups`,
    editDeleteHospitalGroups: `resource/hospital_groups/{id}`,
    getHospitalGroupsListAll: `resource/hospital_groups/all`,
    getHospitalGroupsFirst: `resource/hospital_groups/first`,
  },
  x_a2z_apis: {

    getSchoolsList: `a2z/School/{entity}/List`,
    saveSchools: `a2z/School/{entity}/Create`,
    schoolFetch: `a2z/School/{entity}/Fetch/{id}`,
    schoolsUpdate: `a2z/School/{entity}/Update/{id}`,
    schoolsPartialUpdate: `a2z/School/{entity}/PartialUpdate/{id}`,
    schoolsDelete: `a2z/School/{entity}/Delete/{id}`,

    getProvidersList: `a2z/Provider/{entity}/List`,
    createProviders: `a2z/Provider/{entity}/Create`,
    providerFetch: `a2z/Provider/{entity}/Fetch/{id}`,
    providersUpdate: `a2z/Provider/{entity}/Update/{id}`,
    providersPartialUpdate: `a2z/Provider/{entity}/PartialUpdate/{id}`,
    providersDelete: `a2z/Provider/{entity}/Delete/{id}`,


    getProviderGroupsListAll: `a2z/ProviderGroup/{entity}/getAll`,
    getProviderGroupsList: `a2z/ProviderGroup/{entity}/List`,
    createProviderGroups: `a2z/ProviderGroup/{entity}/Create`,
    providerGroupFetch: `a2z/ProviderGroup/{entity}/Fetch/{id}`,
    providerGroupsUpdate: `a2z/ProviderGroup/{entity}/Update/{id}`,
    providerGroupsPartialUpdate: `a2z/ProviderGroup/{entity}/PartialUpdate/{id}`,
    providerGroupsDelete: `a2z/ProviderGroup/{entity}/Delete/{id}`,

    getMastersList: `a2z/Master/{entity}/getAll?slug={slug}&order_by=name&dir=1`,
    getTimezoneList: `a2z/Timezone/{entity}/getAll`,


    getPatientsList: `a2z/patient/{entity}/List`,
    createPatients: `a2z/patient/{entity}/Create`,
    patientFetch: `a2z/patient/{entity}/Fetch/{id}`,
    patientsUpdate: `a2z/patient/{entity}/Update/{id}`,
    patientsPartialUpdate: `a2z/patient/{entity}/PartialUpdate/{id}`,
    patientsDelete: `a2z/patient/{entity}/Delete/{id}`,

    getUsersList: `a2z/user/{entity}/List`,
    createUsers: `a2z/user/{entity}/Create`,
    userFetch: `a2z/user/{entity}/Fetch/{id}`,
    usersUpdate: `a2z/user/{entity}/Update/{id}`,
    usersPartialUpdate: `a2z/user/{entity}/PartialUpdate/{id}`,
    usersDelete: `a2z/user/{entity}/Delete/{id}`,

    getHospitalListAll: `a2z/Hospital/{entity}/getAll`,
    getHospitalsList: `a2z/Hospital/{entity}/List`,
    createHospitals: `a2z/Hospital/{entity}/Create`,
    hospitalFetch: `a2z/Hospital/{entity}/Fetch/{id}`,
    hospitalsUpdate: `a2z/Hospital/{entity}/Update/{id}`,
    hospitalsPartialUpdate: `a2z/Hospital/{entity}/PartialUpdate/{id}`,
    hospitalsDelete: `a2z/Hospital/{entity}/Delete/{id}`,


    getHospitalGroupsListAll: `a2z/HospitalGroup/{entity}/getAll`,
    getHospitalGroupsList: `a2z/HospitalGroup/{entity}/List`,
    createHospitalGroups: `a2z/HospitalGroup/{entity}/Create`,
    hospitalGroupFetch: `a2z/HospitalGroup/{entity}/Fetch/{id}`,
    hospitalGroupsUpdate: `a2z/HospitalGroup/{entity}/Update/{id}`,
    hospitalGroupsPartialUpdate: `a2z/HospitalGroup/{entity}/PartialUpdate/{id}`,
    hospitalGroupsDelete: `a2z/HospitalGroup/{entity}/Delete/{id}`,


    getContractListAll: `a2z/Contract/{entity}/getAll`,
    getContractList: `a2z/Contract/{entity}/List`,
    createContract: `a2z/Contract/{entity}/Create`,
    ContractFetch: `a2z/Contract/{entity}/Fetch/{id}`,
    ContractUpdate: `a2z/Contract/{entity}/Update/{id}`,
    ContractPartialUpdate: `a2z/Contract/{entity}/PartialUpdate/{id}`,
    ContractDelete: `a2z/Contract/{entity}/Delete/{id}`,


    getstatesListAll: `a2z/state/{entity}/getAll`,
    getstatesList: `a2z/state/{entity}/List`,
    createstates: `a2z/state/{entity}/Create`,
    stateFetch: `a2z/state/{entity}/Fetch/{id}`,
    statesUpdate: `a2z/state/{entity}/Update/{id}`,
    statesPartialUpdate: `a2z/state/{entity}/PartialUpdate/{id}`,
    statesDelete: `a2z/state/{entity}/Delete/{id}`,


    getzonesListAll: `a2z/zone/{entity}/getAll`,
    getzonesList: `a2z/zone/{entity}/List`,
    createzones: `a2z/zone/{entity}/Create`,
    zoneFetch: `a2z/zone/{entity}/Fetch/{id}`,
    zonesUpdate: `a2z/zone/{entity}/Update/{id}`,
    zonesPartialUpdate: `a2z/zone/{entity}/PartialUpdate/{id}`,
    zonesDelete: `a2z/zone/{entity}/Delete/{id}`,


    getparticipantsListAll: `a2z/participant/{entity}/getAll`,
    getparticipantsList: `a2z/participant/{entity}/List`,
    createparticipants: `a2z/participant/{entity}/Create`,
    participantFetch: `a2z/participant/{entity}/Fetch/{id}`,
    participantsUpdate: `a2z/participant/{entity}/Update/{id}`,
    participantsPartialUpdate: `a2z/participant/{entity}/PartialUpdate/{id}`,
    participantsDelete: `a2z/participant/{entity}/Delete/{id}`,


    getparticipantAccessListAll: `a2z/participant_access/{entity}/getAll`,
    getparticipantAccessList: `a2z/participant_access/{entity}/List`,
    createparticipantAccess: `a2z/participant_access/{entity}/Create`,
    participantAccessFetch: `a2z/participant_access/{entity}/Fetch/{id}`,
    participantAccessUpdate: `a2z/participant_access/{entity}/Update/{id}`,
    participantAccessPartialUpdate: `a2z/participant_access/{entity}/PartialUpdate/{id}`,
    participantAccessDelete: `a2z/participant_access/{entity}/Delete/{id}`,

  },
  contract: {
    getContractList: `resource/Contract`,
    getContractFullList: `resource/Contract/all`,
    getContractInfo: `resource/Contract/{id}`,
    saveContract: `resource/Contract`,
    editDeleteContract: `resource/Contract/{id}`,
  },
  referalEntity: {
    getReferalEntityList: `resource/ReferenceEntity`,
    getReferalEntityInfo: `resource/ReferenceEntity/{id}`,
    saveReferalEntity: `resource/ReferenceEntity`,
    editDeleteReferalEntity: `resource/ReferenceEntity/{id}`,
    getReferalEntityListAll: `resource/ReferenceEntity/all`,
  },
  ambulanceInventory: {
    getAmbulanceInventoryList: `resource/AmbulanceInventory`,
    getAmbulanceInventoryInfo: `resource/AmbulanceInventory/{id}`,
    saveAmbulanceInventory: `resource/AmbulanceInventory`,
    editDeleteAmbulanceInventory: `resource/AmbulanceInventory/{id}`,
    getAmbulanceInventoryFirst: `resource/AmbulanceInventory/first`,
    getAmbulanceInventoryListAll: `resource/AmbulanceInventory/all`,
  },
  ambulanceInventoryItem: {
    getAmbulanceInventoryItemList: `resource/AmbulanceInventoryItem`,
    getAmbulanceInventoryItemInfo: `resource/AmbulanceInventoryItem/{id}`,
    saveAmbulanceInventoryItem: `resource/AmbulanceInventoryItem`,
    editDeleteAmbulanceInventoryItem: `resource/AmbulanceInventoryItem/{id}`,
    getAmbulanceInventoryItemFirst: `resource/AmbulanceInventoryItem/first`,
    getAmbulanceInventoryItemListAll: `resource/AmbulanceInventoryItem/all`,
  },
  locationTracker: {
    getLocationTrackerList: `resource/LocationTracker`,
    getLocationTrackerInfo: `resource/LocationTracker/{id}`,
    saveLocationTracker: `resource/LocationTracker`,
    editDeleteLocationTracker: `resource/LocationTracker/{id}`,
    getLocationTrackerFirst: `resource/LocationTracker/first`,
    getLocationTrackerListAll: `resource/LocationTracker/all`,
  },
  favourite: {
    getFavouriteList: `resource/favourites`,
    editDeleteFavourite: `resource/favourites/{id}`,
    saveFavourite: `resource/favourites`,
  },
  notification: {
    listNotification: `listNotification`,
    unreadNotification: `unreadNotification`,
    markReadNotification: `markReadNotification/{id}`,
    readNotification: `readNotification`,
    markallNotification: `markallNotification`,
    unreadCount: `unreadCount`,
  },
  participantAccess: {
    getparticipantAccessList: `resource/participant_access`,
    getparticipantAccessInfo: `resource/participant_access/{id}`,
    saveparticipantAccess: `resource/participant_access`,
    editDeleteparticipantAccess: `resource/participant_access/{id}`,
    getparticipantAccessFirst: `resource/participant_access/first`,
    getparticipantAccessListAll: `resource/participant_access/all`,
  },
  participants: {
    getparticipantsList: `resource/participants`,
    getparticipantsInfo: `resource/participants/{id}`,
    saveparticipants: `resource/participants`,
    editDeleteparticipants: `resource/participants/{id}`,
    getparticipantsFirst: `resource/participants/first`,
    getparticipantsListAll: `resource/participants/all`,
  },
};
